type AlbumTrack = {
  id?: string; sourceType?: string; sourceId?: string; album?: string; albumId?: string | number;
  artists?: string[]; metadata?: Record<string, any>;
};
const normalized = (value: unknown) => String(value ?? '').trim().normalize('NFC');
export function trackPlatform(track: AlbumTrack): 'tx' | 'wy' | '' {
  const value = track.metadata?.platform || track.id?.split(':')[2];
  return value === 'tx' || value === 'qq' ? 'tx' : value === 'wy' ? 'wy' : '';
}
export function albumGroupKey(track: AlbumTrack) {
  const platform = trackPlatform(track);
  const id = normalized(track.albumId || track.metadata?.albumId);
  if (id && id !== '0') return JSON.stringify(['id', platform || track.sourceType || 'local', id.replace(/^qq:album:/, '')]);
  // An album title is not an identity. Unknown IDs are scoped to their artists
  // and storage origin, so unrelated same-name releases never share a page.
  const rawArtists = track.metadata?.albumArtists || track.artists || ['未知艺术家'];
  const artists = (Array.isArray(rawArtists) ? rawArtists : [rawArtists]).map(normalized).filter(Boolean).sort();
  return JSON.stringify(['name', platform || track.sourceType || 'local', normalized(track.album) || '未知专辑', artists]);
}
export function albumRouteId(track: AlbumTrack) {
  const platform = trackPlatform(track);
  const id = normalized(track.albumId || track.metadata?.albumId);
  if (track.sourceType === 'online' && id && id !== '0') return platform === 'tx' ? (id.startsWith('qq:album:') ? id : `qq:album:${id}`) : platform === 'wy' ? id : `local:album:${encodeURIComponent(albumGroupKey(track))}`;
  return `local:album:${encodeURIComponent(albumGroupKey(track))}`;
}
export function matchesAlbumRoute(track: AlbumTrack, route: string) {
  if (route.startsWith('local:album:')) {
    try { return albumGroupKey(track) === decodeURIComponent(route.slice(12)); } catch { return false; }
  }
  // Existing bookmarks and saved routes remain readable. New navigation only
  // emits the scoped form above and never creates another title-only album.
  if (route.startsWith('local:')) {
    let name = route.slice(6); try { name = decodeURIComponent(name); } catch { /* already decoded legacy name */ }
    return (track.album || '未知专辑') === name;
  }
  return albumRouteId(track) === route;
}
